import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetOrganizationListQueryVariables = Types.Exact<{
  input: Types.GetOrganizationListInput;
}>;

export type GetOrganizationListQuery = {
  __typename?: 'Query';
  getOrganizationList: {
    __typename?: 'GetOrganizationListResponse';
    items: Array<{
      __typename?: 'GetOrganizationListResponseOrganization';
      address: string;
      createdAt: string;
      id: number;
      name: string;
      totalClientGroups: number;
      totalUsers: number;
      uuid: string;
    }>;
    pagination?: {
      __typename?: 'PaginationResponse';
      pageNumber: number;
      pageSize: number;
      total: number;
      totalPage: number;
    } | null;
  };
};

export const GetOrganizationListDocument = gql`
  query GetOrganizationList($input: GetOrganizationListInput!) {
    getOrganizationList(input: $input) {
      items {
        address
        createdAt
        id
        name
        totalClientGroups
        totalUsers
        uuid
      }
      pagination {
        pageNumber
        pageSize
        total
        totalPage
      }
    }
  }
`;
export function useGetOrganizationListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrganizationListQuery,
    GetOrganizationListQueryVariables
  > &
    (
      | { variables: GetOrganizationListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrganizationListQuery,
    GetOrganizationListQueryVariables
  >(GetOrganizationListDocument, options);
}
export function useGetOrganizationListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationListQuery,
    GetOrganizationListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganizationListQuery,
    GetOrganizationListQueryVariables
  >(GetOrganizationListDocument, options);
}
export function useGetOrganizationListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetOrganizationListQuery,
        GetOrganizationListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOrganizationListQuery,
    GetOrganizationListQueryVariables
  >(GetOrganizationListDocument, options);
}
export type GetOrganizationListQueryHookResult = ReturnType<
  typeof useGetOrganizationListQuery
>;
export type GetOrganizationListLazyQueryHookResult = ReturnType<
  typeof useGetOrganizationListLazyQuery
>;
export type GetOrganizationListSuspenseQueryHookResult = ReturnType<
  typeof useGetOrganizationListSuspenseQuery
>;
export type GetOrganizationListQueryResult = Apollo.QueryResult<
  GetOrganizationListQuery,
  GetOrganizationListQueryVariables
>;
export function refetchGetOrganizationListQuery(
  variables: GetOrganizationListQueryVariables,
) {
  return { query: GetOrganizationListDocument, variables: variables };
}
